(function () {
  if (window.__SH_STICKY_ATC_INIT__) return;
  window.__SH_STICKY_ATC_INIT__ = true;

  function q(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getProductTitle() {
    var el =
      q('.product__title') ||
      q('.product-title') ||
      q('[data-product-title]') ||
      q('h1');

    return el ? el.textContent.replace(/\s+/g, ' ').trim() : 'Product';
  }

  function getPriceText() {
    var selectors = [
      '.price-item--sale',
      '.price-item--regular',
      '.product__price',
      '.product-price',
      '.price'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = q(selectors[i]);
      if (el) {
        var txt = el.textContent.replace(/\s+/g, ' ').trim();
        if (txt) return txt;
      }
    }

    return '';
  }

  function getAddToCartForm() {
    var forms = qa('form[action*="/cart/add"]');
    if (!forms.length) return null;

    for (var i = 0; i < forms.length; i++) {
      var btn =
        forms[i].querySelector('button[name="add"]') ||
        forms[i].querySelector('[type="submit"]');
      if (btn) return forms[i];
    }

    return forms[0];
  }

  function getPrimaryAddToCartButton() {
    return (
      q('form[action*="/cart/add"] button[name="add"]') ||
      q('form[action*="/cart/add"] [type="submit"]') ||
      q('.product-form__submit') ||
      q('[name="add"]')
    );
  }

  function ensureBar() {
    var existing = document.getElementById('shStickyATCGlobal');
    if (existing) return existing;

    var bar = document.createElement('div');
    bar.id = 'shStickyATCGlobal';
    bar.className = 'sh-sticky-atc';
    bar.innerHTML =
      '<div class="sh-sticky-atc__inner">' +
        '<div class="sh-sticky-atc__meta">' +
          '<div class="sh-sticky-atc__title" id="shStickyTitleGlobal"></div>' +
          '<div class="sh-sticky-atc__sub" id="shStickySubGlobal"></div>' +
        '</div>' +
        '<button class="sh-sticky-atc__cta" id="shStickyBtnGlobal" type="button">Add to Cart</button>' +
      '</div>';

    document.body.appendChild(bar);
    return bar;
  }

  function updateBar() {
    var titleEl = document.getElementById('shStickyTitleGlobal');
    var subEl = document.getElementById('shStickySubGlobal');
    var btn = document.getElementById('shStickyBtnGlobal');

    if (!titleEl || !subEl || !btn) return;

    var title = getProductTitle();
    var price = getPriceText();

    titleEl.textContent = title || 'Product';
    subEl.textContent = price || '';

    btn.onclick = function () {
      var realBtn = getPrimaryAddToCartButton();
      if (realBtn) {
        realBtn.click();
        return;
      }

      var form = getAddToCartForm();
      if (form) {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }
    };
  }

  function bindVisibility() {
    var bar = document.getElementById('shStickyATCGlobal');
    if (!bar) return;

    var ticking = false;

    function updateVisibility() {
      ticking = false;

      if (!isMobile()) {
        bar.style.display = 'none';
        return;
      }

      var mainButton = getPrimaryAddToCartButton();
      if (!mainButton) {
        bar.style.display = 'none';
        return;
      }

      var rect = mainButton.getBoundingClientRect();
      var viewportH = window.innerHeight || document.documentElement.clientHeight;

      var buttonInView = rect.top < viewportH && rect.bottom > 0;

      bar.style.display = buttonInView ? 'none' : 'block';
    }

    function onScrollOrResize() {
      if (!ticking) {
        window.requestAnimationFrame(updateVisibility);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    window.addEventListener('orientationchange', onScrollOrResize);

    updateVisibility();
  }

  function init() {
    if (!isMobile()) return;
    ensureBar();
    updateBar();
    bindVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', init);
})();